import React, { useEffect } from "react"
import { View, StyleSheet } from "react-native"
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
} from "react-native-reanimated"
import { BFColors } from "@/constants/Colors"

interface ProgressBarProps {
  progress: number // Progress in percentage (0-100)
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  const animatedValue = useSharedValue(0)

  useEffect(() => {
    animatedValue.value = withTiming(progress, { duration: 1000 })
  }, [progress])

  const animatedStyle = useAnimatedStyle(() => {
    return {
      width: `${animatedValue.value}%`,
    }
  })

  return (
    <View style={styles.background}>
      <Animated.View style={[styles.progressBar, animatedStyle]} />
    </View>
  )
}

const styles = StyleSheet.create({
  background: {
    height: 5,
    backgroundColor: BFColors.offWhite,
    borderRadius: 10,
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    backgroundColor: BFColors.midnightBlue,
    borderRadius: 10,
  },
})

export default ProgressBar
